module.exports = __webpack_public_path__ + "img/pt.0273f969.png";